/** Format STAC `properties.datetime` for table display (ui-canvas `formatDateTime`). */
export function formatStacDateTime(dateTimeString: string): string {
  try {
    const date = new Date(dateTimeString);
    if (Number.isNaN(date.getTime())) {
      return dateTimeString;
    }
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    });
  } catch {
    return dateTimeString;
  }
}

/** Parse `input[type=date]` value (yyyy-mm-dd) to UTC start-of-day ms. */
export function dateInputToStartMs(value: string): number | null {
  const trimmed = value.trim();
  if (!trimmed) return null;
  const ms = Date.parse(`${trimmed}T00:00:00.000Z`);
  return Number.isFinite(ms) ? ms : null;
}

/** Parse `input[type=date]` value to UTC end-of-day ms. */
export function dateInputToEndMs(value: string): number | null {
  const trimmed = value.trim();
  if (!trimmed) return null;
  const ms = Date.parse(`${trimmed}T23:59:59.999Z`);
  return Number.isFinite(ms) ? ms : null;
}

/**
 * Build STAC Items API `datetime` interval query value.
 * Example: `2026-06-01T00:00:00Z/2026-07-14T00:00:00Z`
 */
export function buildStacDatetimeInterval(from: string, to: string): string | null {
  const fromTrimmed = from.trim();
  const toTrimmed = to.trim();
  if (!fromTrimmed && !toTrimmed) {
    return null;
  }
  const start = fromTrimmed ? `${fromTrimmed}T00:00:00Z` : '..';
  const end = toTrimmed ? `${toTrimmed}T00:00:00Z` : '..';
  return `${start}/${end}`;
}
